/** @typedef {import("aerosync-web-sdk").AerosyncWidget} AerosyncWidget */
/** @typedef {import("aerosync-web-sdk").WidgetEventType} WidgetEventType */
/** @typedef {import("aerosync-web-sdk").WidgetEventSuccessType} WidgetEventSuccessType */

import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import clientInformation from '../login/ClientInfo';
import Alerts from '../helpers/Alerts';
import { IsValidToken, CheckCustomerData, GetCustomerInfo } from "../../services/AuthenticationService";
import { EWalletDeposit, VerifyAeropayUser, LinkAeropayBank, ConfirmAeropayUser } from "../../services/DepositService";
import Loading from '../helpers/Loader';
import BeatLoader from "react-spinners/BeatLoader"
import { onlyNumbers, BonusString } from '../helpers/common';
import Bonus from '../Bonus';
import { MissingAccountInfo } from "../deposit/MissingAccountInfo.jsx";
import { isMobile } from 'react-device-detect';
import { AerosyncWidget, WidgetEventSuccessType, WidgetEventType } from "aerosync-web-sdk";
import { initAeroSyncWidget } from "aerosync-web-sdk";
import Swal from 'sweetalert2';


export const AeropayMethods = () => {
    const { id } = useParams();
    const clientInfo = clientInformation();
    let INSTANCEID = clientInfo.InstanceID;
    let MAXLIMIT = process.env.REACT_APP_MaxLimit;
    const [isLoading, setIsLoading] = useState(true);
    const [isValidate, setIsValidate] = useState(true);
    const [isProcessing, setIsProcessing] = useState(false);
    const navigate = useNavigate();
    const [arrayAeropayDeposits, setAeropayDeposits] = useState(JSON.parse(localStorage.getItem('ArrayRegularMethods')).filter(function (element) { return element.DepositID == id; })[0]);
    const [showInstructions, setshowInstructions] = useState(true);
    const [showResponse, setshowResponse] = useState(false);
    const [disableControl, setDisableControl] = useState(false);

    useEffect(() => {
        IsValidToken(localStorage.getItem('Token')).then(async function (response) {
            await doCheckCustomerData();
           
            setIsLoading(false);
        }

        ).catch(function (error) {
            navigate('/expired/');
        })

        if (arrayAeropayDeposits == undefined) {
            navigate('/deposits/');
        }
        

    }, []);

    /**
     * Opens the AeroSync widget and handles its lifecycle events.
     * @returns {void}
     */
    async function openAerosyncWidget(ewamount) {
        await GetCustomerInfo(localStorage.getItem('Token')).then(async function (response) {
            //Check Phone Format
            if (response.Authentication.Phone == "")
                Alerts.ShowAlert('Warning', 'Please contact support, you need to provide a valid phone', 'warning');
            else {

                var formattedPhone = response.Authentication.Phone.startsWith("1")
                    ? "+" + response.Authentication.Phone
                    : "+1" + response.Authentication.Phone;

                var email = response.Authentication.Email;
                //Validate Customer
                var formData = {
                    Token: localStorage.getItem('Token'),
                    Name: clientInfo.Name,
                    LastName: clientInfo.LastName,
                    Email: response.Authentication.Email,
                    Phone: formattedPhone /*'+18554782198'*/
                }
                await VerifyAeropayUser(formData).then(async function (response) {
                    setIsProcessing(false);
                    if (response.output.Success) {
                        if (response.output.ShowWidget) {
                            /** @type {AerosyncWidget} */
                            let widgetControls = initAeroSyncWidget({
                                elementId: "widget",
                                iframeTitle: "Connect",
                                environment: "production",
                                consumerId:"9bddc6c3-da24-4a4c-be7a-df8b55c6e695",
                                token: response.output.WidgetToken,
                                theme: "light",

                                /**
                                 * @param {WidgetEventType} event
                                 */
                                onEvent(event) {
                                    console.log("event", event);
                                },

                                onLoad() {
                                    console.log("onload");
                                },

                                /**
                                 * @param {WidgetEventSuccessType} event
                                 */
                                onSuccess(event) {
                                    console.log("onSuccess", event);
                                    var formData = {
                                        Token: localStorage.getItem('Token'),
                                        WidgetUserId: event.user_id,
                                        WidgetUserPassword: event.user_password,
                                        AeropayUserId: response.output.UserId
                                    };

                                    LinkAeropayBank(formData).then(async function (response) {
                                        if (response.output.Success) {
                                            setIsProcessing(true);
                                            await doEWalletDeposit(ewamount, response.output.UserId, response.output.BankId).then(async function (response) {
                                                    
                                            });

                                            setIsProcessing(false);
                                            //Alerts.ShowAlert('', response.output.Message + " now the transaction will be created", 'success');
                                           
                                        }
                                        else {
                                            Alerts.ShowAlert('Warning', response.output.Message, 'warning');
                                        }
                                    });
                                },

                                onClose() {
                                    console.log("widget closed");
                                    //Alerts.ShowAlert('Warning', 'create transaction', 'warning');
                                },

                                /**
                                 * @param {string} event
                                 */
                                onError(event) {
                                    console.log("onError", event);
                                },
                            });

                            widgetControls.launch();
                        }
                        else if (response.output.ShowConfirmation) {
                            ShowConfirmation(response.output, formattedPhone, email, ewamount);
                        }
                        else {
                            if (response.output.BankId != '') {
                                if (response.output.BankList && response.output.BankList.length > 0) {
                                    const bankOptionsHtml = response.output.BankList.map((bank, index) => `
                                        <div class="form-check m-1">
                                            <input class="form-check-input" type="radio" name="selectedBank" id="bank-${index}" value="${bank.BankAccountId}" ${index === 0 ? 'checked' : ''}>
                                            <label class="form-check-label" for="bank-${index}">
                                                <strong>${bank.BankName}</strong><br/>
                                                <small>${bank.Name}</small>
                                            </label>
                                        </div>
                                    `).join('');

                                    Swal.fire({
                                        title: 'Select Bank Account',
                                        html: `
                                            <div class="text-start">
                                                ${bankOptionsHtml}
                                                <div class="mt-3 d-flex justify-content-between align-items-center">
                                                    <button id="add-new-bank-btn" class="btn btn-outline-primary btn-sm">+ Add New Bank</button>
                                                    <div>
                                                        <button id="confirm-btn" class="swal2-confirm swal2-styled">Make Purchase</button>
                                                        <button id="cancel-btn" class="btn btn-danger btn-sm ms-2">Cancel</button>
                                                    </div>
                                                </div>
                                            </div>
                                        `,
                                        showConfirmButton: false,
                                        showCancelButton: false,
                                        didOpen: () => {
                                            // Add New Bank logic
                                            document.getElementById('add-new-bank-btn')?.addEventListener('click', () => {
                                                Swal.close(); // ? Close the modal first

                                                let widgetControls = initAeroSyncWidget({
                                                    elementId: "widget",
                                                    iframeTitle: "Connect",
                                                    environment: "production",
                                                    consumerId: "9bddc6c3-da24-4a4c-be7a-df8b55c6e695",
                                                    token: response.output.WidgetToken,
                                                    theme: "light",
                                                    onEvent(event) {
                                                        console.log("event", event);
                                                    },
                                                    onLoad() {
                                                        console.log("onload");
                                                    },
                                                    onSuccess(event) {
                                                        console.log("onSuccess", event);
                                                        var formData = {
                                                            Token: localStorage.getItem('Token'),
                                                            WidgetUserId: event.user_id,
                                                            WidgetUserPassword: event.user_password,
                                                            AeropayUserId: response.output.UserId
                                                        };

                                                        LinkAeropayBank(formData).then(async function (response) {
                                                            console.log(response);
                                                            if (response.output.Success) {
                                                                /*setIsProcessing(true);
                                                                await doEWalletDeposit(ewamount, response.output.UserId, response.output.BankId);
                                                                setIsProcessing(false);*/
                                                                setDisableControl(false);
                                                                Alerts.ShowAlert('Success', response.output.Message, 'success');

                                                            } else {
                                                                Alerts.ShowAlert('Warning', response.output.Message, 'warning');
                                                            }
                                                        });
                                                    },
                                                    onClose() {
                                                        console.log("widget closed");
                                                    },
                                                    onError(event) {
                                                        console.log("onError", event);
                                                    },
                                                });

                                                widgetControls.launch();
                                            });

                                            // Confirm button logic
                                            document.getElementById('confirm-btn')?.addEventListener('click', async () => {
                                                const selectedBankId = document.querySelector('input[name="selectedBank"]:checked')?.value;
                                                if (!selectedBankId) {
                                                    Swal.showValidationMessage('Please select a bank');
                                                    return;
                                                }
                                                Swal.close();
                                                setIsProcessing(true);
                                                await doEWalletDeposit(ewamount, response.output.UserId, selectedBankId);
                                                setIsProcessing(false);
                                            });

                                            // Cancel button logic
                                            document.getElementById('cancel-btn')?.addEventListener('click', () => {
                                                Swal.close();
                                            });
                                        }
                                    });


                                } else {
                                    Alerts.ShowAlert('Warning', response.output.Message, 'warning');
                                }


                                //setIsProcessing(true);


                                //await doEWalletDeposit(ewamount, response.output.UserId, response.output.BankId);
                                //setIsProcessing(false);
                                //Alerts.ShowAlert('Info', 'create transaction, using bankId: ' + response.output.BankId , 'success');
                            }
                            else {
                                Alerts.ShowAlert('Warning', response.output.Message, 'warning');
                            }
                        }
                    }
                    else {
                        Alerts.ShowAlert('Warning', response.output.Message, 'warning');
                    }

                });
            }
           
        });
    }

    function ShowConfirmation(output, phone, email, ewamount) {
        Swal.fire({
            title: 'Verification Required ',
            html: `
            <img class="aeropay-logo" src="/svg/aeropaylarge.svg" />
            <p>${output.Message}</p>
            <input type="text" id="verification-code" class="swal2-input" placeholder="Enter verification code">
            `,
            showCancelButton: true,
            confirmButtonText: 'Verify',
            cancelButtonText: 'Cancel',
            preConfirm: () => {
                const code = document.getElementById('verification-code').value;
                if (!code) {
                    Swal.showValidationMessage('Please enter the verification code');
                    return false;
                }
                return code;
            }
        }).then((result) => {
            if (result.isConfirmed && result.value) {
                setIsProcessing(true);
                // Call confirmuser from Recovery controller
                var formData = {
                    Token: localStorage.getItem('Token'),
                    UserId: output.UserId,
                    MFACode: result.value,
                    Phone: phone,
                    Email: email
                }
                ConfirmAeropayUser(formData).then(async function (response) {
                    if (!response.output.Success) {
                        setIsProcessing(false);
                        Swal.fire('Error Confirmation', response.output.Message || 'Verification failed', 'error');
                    }
                    else {
                        await doEWalletDeposit(ewamount, response.output.UserId, response.output.BankId);
                        setIsProcessing(false);
                    }
                });
            }
        });
    }

    function handleResponseFromComponent(response){
        setIsValidate(response);
    }

    async function doCheckCustomerData() {
        await CheckCustomerData(localStorage.getItem('Token'),'aeropay').then(async function (response) {
            if (!response.Authentication.AllComplete) {
                setIsValidate(true);
            }
            else {
                setIsValidate(false);
            }
        })
    };

    async function doEWalletDeposit(Amount, Account, SecureID) {

        var Data =
        {
            "Token": localStorage.getItem('Token'),
            "eWalletAccount": Account,
            "eWalletPassword": SecureID,
            "ProcessorName": arrayAeropayDeposits.DepositName,
            "InstanceID": INSTANCEID,
            "Amount": Amount,
            "CurrencyCode": "USD",
            "returnURL": "",
            "statusURL": "",
            "TransactionID": "-1",
            "IPv4Address": clientInfo.IPAddress,
            "BonusList": BonusString(JSON.parse(localStorage.getItem('ArrayBonus')))
        };

        await EWalletDeposit(Data).then(function (response) {

            try {
                var payload = {
                    TransactionID: response.Authentication.TransactionID,
                    Amount: Amount,
                    Status: response.Authentication.status,
                    ProcessorName: response.Authentication.ProcessorName
                }

                window.parent.postMessage(
                    { 'transactionInfo': payload },
                    '*'
                );
            }
            catch (error) { }

            if (response.Authentication.ErrorCode != undefined && response.Authentication.ErrorCode != null) {

                if (isMobile) {
                    Alerts.ShowAlertFullScreen('Error with Aeropay Purchase', response.Authentication.ErrorDescription, 'error');
                }
                else {
                    Alerts.ShowAlert('Error with Aeropay Purchase', response.Authentication.ErrorDescription, 'error');
                }

            }
            else {
                var message = response.Authentication.HtmlResponse;
                if (response.Authentication.status == "PENDING") {
                    if (isMobile) {
                        Alerts.ShowAlertFullScreen('Aeropay Purchase Info', message, 'info');
                    }
                    else {
                        Alerts.ShowAlert('Aeropay Purchase Info', message, 'info');
                    }
                }
                else if (response.Authentication.status == "REJECTED") {
                    if (isMobile) {
                        Alerts.ShowAlertFullScreen('Aeropay Purchase Rejected', message, 'info');
                    }
                    else {
                        Alerts.ShowAlert('Aeropay Purchase Rejected', message, 'info');
                    }

                }
                else {
                    if (isMobile) {
                        Alerts.ShowAlertFullScreen('Aeropay Purchase Info', message, 'info');
                    }
                    else {
                        Alerts.ShowAlert('Aeropay Purchase Info', message, 'info');
                    }
                }

            }

        })
            .catch(function (error) {
                if (isMobile) {
                    Alerts.ShowAlertFullScreen('Error', 'Error making Purchase', 'error');
                }
                else {
                    Alerts.ShowAlert('Error', 'Error making Purchase', 'error');
                }

            })


    }
    
    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!isProcessing) {
            var data = new FormData(event.target);
            let { ewamount } = Object.fromEntries(data.entries());
            if (ewamount != '') {
                setDisableControl(true);
                setIsProcessing(true);
                //await InitiateTransaction(ewamount);
                await openAerosyncWidget(ewamount);
            }
            else {
                Alerts.ShowAlert('Warning', 'Amount required', 'warning');
            }
        }
    }

    if (isValidate) {
        return <MissingAccountInfo Processor={'zelle'} isValidate={handleResponseFromComponent.bind(isValidate)} />;/* arrayAeropayDeposits.ProcessorID*/
    }

    if (isLoading) {
        return <Loading />;
    }

    return (
        <div className="componentload">
            <div className="row m-4">
                <div className="col-md-12 col-sm-12 icon-single-left logo-highlight">
                    <span className="xt-primary" style={{ fontSize: "1.5rem" }}>
                        <b className="mr-2">Pay by Bank via </b> <img style={{ width: "140px" }} src="/svg/aeropaylarge.svg" />
                    </span>
                </div>
            </div>
            
            <form onSubmit={handleSubmit}>
                <div id="widget"></div>
                <div className={showInstructions ? "show-element" : null}>
                    {showInstructions && <div className="row" >
                        <div className="col-md-12 m-2" >
                            <div className="alert alert-primary text-center" role="alert">
                                Clicking on purchase you will be required to link your bank account to the system, using our regulated aeropay solution.  In case you have already a registered bank account the system will create the transaction automatically.
                            </div>
                        </div>
                        <div className="offset-md-3 col-md-6 col-sm-12 col-xs-12 mb-3" >
                            <div className="input-group m-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-currency-cards d-none d-md-block" id="lblCurrency">
                                        <select className="form-control selectcurrency" disabled="" name="ccCurrency" required="" value={clientInfo.CurrencyCode}>
                                            <option value="" className="">Currency</option>
                                            <option value="USD">USD</option>
                                        </select>
                                    </span>
                                </div>
                                <input type="number" disabled={disableControl} onKeyPress={(event) => onlyNumbers(event)}  className="form-control color-gray border-teal" aria-label="Amount (to the nearest dollar)" placeholder="Amount" name="ewamount" max={arrayAeropayDeposits?.MaxDeposit == 0 ? MAXLIMIT : arrayAeropayDeposits?.MaxDeposit} min={arrayAeropayDeposits?.MinDeposit == 0 ? 1 : arrayAeropayDeposits?.MinDeposit} aria-describedby="lblCurrency" required="" />
                            </div>
                            <div className="d-flex flex-row ml-2 limit-text-center ">
                                Deposit Limits: Minimum {arrayAeropayDeposits?.MinDeposit == 0 ? 1 : arrayAeropayDeposits?.MinDeposit} USD Maximum {arrayAeropayDeposits?.MaxDeposit == 0 ? 'No Limit' : arrayAeropayDeposits?.MaxDeposit + ' USD'}
                            </div>
                        </div>
                        <Bonus ProcessorName="aeropay" />
                        <div className="col-md-12 mb-3-small mt-4">
                            <button type="button" className="btn btn-secondary btn-gray btn-back-order mb-4 d-none d-md-block" onClick={() => navigate('/deposits/')}>BACK</button>
                            <button type="submit" disabled={disableControl} className="btn btn-deposit btn-lightgreen btn-deposit-order mb-4 submit">PURCHASE</button>
                        </div>
                    </div>}
                </div>
            </form>

            <div >
                {isProcessing && <Loading />}
            </div>

        </div>
    );
}